export const ACCESS_TOKEN = "CZF_FCIM_AT";
export const ACCESS_TOKEN_EXPIRES = "CZF_FCIM_ATE";
export const REFRESH_TOKEN = "CZF_FCIM_RT";
export const REFRESH_TOKEN_EXPIRES = "CZF_FCIM_RTE";
export const IS_ADMIN = "IS_ADMIN";
export const ROLE = "ROLE";
export const SITE_DETAILS = "SITE_DETAILS";

